import React, { useEffect, useState, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSort } from '@fortawesome/free-solid-svg-icons'

import clsx from 'clsx'

import { Header2 } from '../utils/Header'
import { buttonColors } from '../utils/Button'

import { PRODUCTS } from '../../utils/constants'

const Sms = ({ onChange, standalone = true }) => {
  const adjustRef = useRef()
  const [selected, setSelected] = useState(PRODUCTS.sms.items[1])
  const [adjustedAmount, setAdjustedAmount] = useState(PRODUCTS.sms.items[1].value)

  useEffect(() => {
    selected && onChange(selected.value)
    selected && setAdjustedAmount(selected.value)
  }, [selected])

  useEffect(() => {
    adjustedAmount && onChange(adjustedAmount)
  }, [adjustedAmount])

  const ListItem = ({ onChange }) => {
    return PRODUCTS.sms.items.map((item, i) => (
      <div
        key={i}
        className={clsx(
          'w-full rounded-md border-2 text-center cursor-pointer ',
          'p-1 sm:px-2 sm:py-3',
          'mr-1 md:mr-3 flex justify-between space-x-6 mb-2',
          item.value === selected.value ? buttonColors['green'] : buttonColors['gray']
        )}
        onClick={() => setSelected(item)}
      >
        <div className="text-xl font-medium pl-2">${item.value}</div>
        <div className="text-xl font-medium pr-2">+{item.count}</div>
      </div>
    ))
  }

  const handleAdjustCange = e => {
    const midHeight =
      (adjustRef.current.getBoundingClientRect().bottom - adjustRef.current.getBoundingClientRect().top) / 2
    const clickPosition = e.clientY - adjustRef.current.getBoundingClientRect().top

    const nextValue = adjustedAmount + (midHeight > clickPosition ? 1 : -1)
    setAdjustedAmount(nextValue > 0 ? nextValue : 1)
  }

  return (
    <div>
      {standalone && <Header2>Add additional SMS Capacity</Header2>}
      <div className="flex items-center justify-around">
        <div className="w-1/2 text-5xl flex flex-col space-y-4 text-center font-semibold tracking-wider">
          <span className="">+{selected.count}</span>
          <div className="flex items-center justify-center space-x-4">
            <span>${adjustedAmount}</span>
            {selected && selected.value === 5 && (
              <div ref={adjustRef}>
                <FontAwesomeIcon icon={faSort} className=" text-gray-400" onClick={handleAdjustCange} />
              </div>
            )}
          </div>
        </div>
        <div className="w-1/2">
          <ListItem />
        </div>
      </div>
    </div>
  )
}

export default Sms
